import React from 'react'
import { useState } from 'react'

export default function useModal() {
  const [isOpen, toggle] = useState(false)
  function toggleModal() {
    isOpen ? toggle(false) : toggle(true)
  }
  return [isOpen,toggleModal] as const
}

